/*
 * @Author: jin.li 1754611189@qq.com
 * @Date: 2025-06-25 11:04:13
 * @LastEditors: jin.li 1754611189@qq.com
 * @LastEditTime: 2025-06-30 11:24:45
 * @FilePath: \cbest-welfare-erp-h5\src\views\Product\Area\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Space, Form, Input, Button, Select, Card, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import service from "../../../@services";
import { useEffect, useState } from "react";
import AreaPageTable from "./components/AreaPageTable";
import AuthComponent from "../../../components/AuthComponent";
import ModalComponent from "./components/modalComponent";
import * as Utils from '../../../@utils'
export default function Brand(props) {
  const [form] = Form.useForm();
  const [selectedRowKeys, onSelectChange] = useState([])
  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState({})
  const [modalVisible, setModalVisible] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [modalData, setModalData] = useState({})
  useEffect(() => {
    onSearch()
  }, []);
  const onSearch = ({pageIndex=1, pageSize=10} = {}) => {
    const pagination = {pageIndex: pageIndex, pageSize: pageSize}
    const params = Object.assign({},form.getFieldsValue(),pagination)
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    const data = await service.area.getAreaPageList(params)
    setLoading(false)
    if(data){
      setTableData(data)
    }
  }
  const addArea = () => { 
    setModalTitle('新建可售区域模板')
    setModalData({})
    setModalVisible(true)
  }
  const editArea = (record) => {
    setModalTitle('编辑可售区域模板')
    setModalData(record)
    setModalVisible(true)
  }
  // 关闭弹窗
  const closeModal = () => setModalVisible(false)
  // 表单提交
  const submitModal = (val) => {
    const subData = {
      ...val
    }
    if (modalTitle === '新增') {
      service.area.saveArea(subData).then(res => {
        message.success('新增成功')
        setModalVisible(false)
        onSearch()
      }).catch(err => console.log(err))
    } else {
      subData.id = val.id
      service.area.saveArea(subData).then(res => {
        message.success('编辑成功')
        setModalVisible(false)
        onSearch()
      }).catch(err => console.log(err))
    }
  }
  
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card style={{ height: "100%", flexGrow: 1 }}>
        <Space style={{ display: "flex", padding: "15px 0", marginTop: "-24px" }}>
          <AuthComponent authKey="/brand/create">
            <Button type="primary" icon={<PlusOutlined />} onClick={()=>{ addArea() }}>新建模板</Button>
          </AuthComponent>
        </Space>
        <AreaPageTable 
          dataSource={tableData}
          rowSelection={rowSelection}
          loading={loading}
          editArea={(record)=>{editArea(record)}}
          handleTableChange={onSearch} />
      </Card>
      <ModalComponent
        visible={modalVisible}
        title={modalTitle}
        modalData={modalData}
        onCancel={closeModal}
        onOk={submitModal}
      />
    </Space>
  );
}
